<template>
<div>
    <div class="header-spacer"></div>
    <div style="width:100%; text-align:center;"><h1>Submit Content</h1></div>
    <div style="width:100%;">
        <div style="width: 80%; margin: auto;">
            <p>DiscoverLewisCounty.com aims to be a resource promoting tourism in Lewis County, Washington. If you have an event, restaurant, lodging, retail establishment or farm that you would like to see added to our site, please use this form.</p>
            <p>Submissions to DiscoverLewisCounty.com must fit within a theme of promoting tourism, and as such must be within the geographical boundaries of Lewis County and any of its cities or communities. Events must be open, whether free or paid, to all people from inside and outside the Lewis County area.</p>
            <p>Examples of events that would qualify include festivals, live theatre, fishing derbies, sports tournaments, community celebrations, and the like. Events that would not qualify, for example, include meetings of local civil service organizations, networking gatherings, anything designed for a primarily hyperlocal audience, is not open to all or does not fit within the general theme of tourism.</p>
            <p>Thank you in advance for your submission. Once the form is complete, our team will review your entry and be in touch with you as soon as possible.</p>
        </div>
        <form class="form" @submit="onSubmit" style="width:50%; margin: auto;">
            <strong :class="{ invalid_label: result.errors.hasOwnProperty('content_type_select')}">Which type of content would you like to submit? *<span v-if="result.errors['content_type_select']"> -- {{ result.errors['content_type_select'][0] }}</span></strong>
            <div>
                <input type="radio" name="content_type_select" id="up_event" value="Upcomming Event" required v-model="formData.content_type">
                <label for="up_event" style="display: inline-block"><strong>Upcoming Event</strong></label>
            </div>
            <div>
                <input type="radio" name="content_type_select" id="rest_cof_caf" value="Restaurant, Coffee Shop, Cafe, etc." v-model="formData.content_type">
                <label for="rest_cof_caf" style="display: inline-block"><strong>Restaurant, Coffee Shop, Cafe, etc.</strong></label>
            </div>
            <div>
                <input type="radio" name="content_type_select" id="lod_air_vr" value="Lodging, Airbnb or VRBO" v-model="formData.content_type">
                <label for="lod_air_vr" style="display: inline-block"><strong>Lodging, Airbnb or VRBO</strong></label>
            </div>
            <div>
                <input type="radio" name="content_type_select" id="retail" value="Retail Establishment" v-model="formData.content_type">
                <label for="retail" style="display: inline-block"><strong>Retail Establishment</strong></label>
            </div>
            <div>
                <input type="radio" name="content_type_select" id="farm" value="Farm, Farm Stand or Market" v-model="formData.content_type">
                <label for="farm" style="display: inline-block"><strong>Farm, Farm Stand or Market</strong></label>
            </div>
            <br>
            
            <label for="details" :class="{ invalid_label: result.errors.hasOwnProperty('details') }"><strong>Please describe your submission in detail:*</strong><span v-if="result.errors['details']"> -- {{ result.errors['details'][0] }}</span></label>
            <textarea name="details" required id="details" cols="30" rows="5" v-model="formData.details" :class="{ invalid_field: result.errors.hasOwnProperty('details') }" placeholder="Give as many details as possible about your entry, including location, price, who's invited, and more."></textarea>
            
            <label for="address" :class="{ invalid_label: result.errors.hasOwnProperty('address') }"><strong>Give as exact an addresss as possible:*</strong><span v-if="result.errors['address']"> -- {{ result.errors['address'][0] }}</span></label>
            <input type="text" required v-model="formData.address" :class="{ invalid_field: result.errors.hasOwnProperty('address') }" id="address" placeholder="Example: 123 Main Street, Anytown, USA 12345">

            <label for="website" :class="{ invalid_label: result.errors.hasOwnProperty('website') }"><strong>What is the website or social media page for your entry?*</strong><span v-if="result.errors['website']"> -- {{ result.errors['website'][0] }}</span></label>
            <input type="text" required v-model="formData.website" :class="{ invalid_field: result.errors.hasOwnProperty('website') }" id="website">

            <!-- File Uploader Here -->
            <label :class="{ invalid_label: result.errors.hasOwnProperty('file') }">File
                <input type="file" id="file" ref='file' required v-on:change="handleFileUpload()">
                <span v-if="result.errors['file']"> -- {{ result.errors['file'][0] }}</span>
            </label>

            <label for="contact" :class="{ invalid_label: result.errors.hasOwnProperty('contact') }"><strong>What is the best way to contact you?*</strong><span v-if="result.errors['contact']"> -- {{ result.errors['contact'][0] }}</span></label>
            <input type="text" required v-model="formData.contact" :class="{ invalid_field: result.errors.hasOwnProperty('contact') }" id="contact" placeholder="Enter your email address, phone number or other form of communication.">

            <vue-recaptcha ref="recaptcha" sitekey="6LemX98UAAAAAIG2tbCaZr8K0mU0shNYfGkOodyA" size="normal" :loadRecaptchaScript="true" @verify="onCaptchaVerified" @expired="onCaptchaExpired">
                <button type="submit" ref="sub_button" style="width:100%;" :disabled="disableSubmit">Submit</button>
            </vue-recaptcha>
        </form>
        <div style="width:50%; margin:auto; text-align:center;">
            <p>{{ result.message }}</p>
        </div>
        <div class="form-message" :class="{ active: result.message }">
            <p v-if="result.message">{{ result.message }} <span v-for="item in result.errors" :key="item[0]"> {{ item[0] }}</span></p>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'
// import Page from '../views/Page.vue'
export default{
    name: 'submitcontent',
    data() {
        return {
            formData: {
                content_type: '',
                details: '',
                address: '',
                website: '',
                file: '',
                contact: '',
                recaptchaToken: '',
            },
            result: {
                success: null,
                message: null,
                errors: {},
            },
            disableSubmit: false,
        }    
    },
    components: {
        VueRecaptcha
    },
    methods:{
        clearForm() {
            for (let field in this.formData) {
                this.formData[field] = '';
            }
        },
        handleFileUpload() {
            const file = this.$refs.file.files[0];
            this.formData.file = file;
            if (file) {
                if (file.size > 1024 * 1024) {
                    this.disableSubmit = true;
                    this.result.message = 'The file is to big to submit.';
                } else {
                    this.disableSubmit = false;
                    this.result.message = null;
                }
            } else {
                this.formData.file = '';
                this.disableSubmit = false;
                this.result.message = null;
            }
        },
        onSubmit(evt) {
            evt.preventDefault();
            this.disableSubmit = true;
            this.result.success = null;
            this.result.message = null;
            this.result.errors = {};
            let csrftoken = this.getCookie('csrftoken');
            let headers = {
                'X-CSRFToken': csrftoken,
                'Content-Type': 'multipart/form-data',
                'credentials': 'include',
            }
            setTimeout(() => {
                let form = new FormData();
                for (let field in this.formData) {
                    form.append(field, this.formData[field])
                }
                let vueObj = this;
                axios.post('/api/submit_form/', form, {headers: headers}).then((response) => {
                    console.log(response);
                    this.result['success'] = response.data.success;
                    this.result['message'] = response.data.message;
                    if (response.data.errors) {
                        this.result.errors = response.data.errors;
                    }
                    if (response.data.success) {
                        this.clearForm();
                    }
                }).catch((e) => {
                    console.log(e);
                    this.result['success'] = false;
                    this.result['message'] = "There was an error sending your message."
                }).then(function () {
                    vueObj.$refs.recaptcha.reset();
                    vueObj.disableSubmit = false;
                })
            }, 1000);
        },
        getCookie(name) {
            var cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = cookies[i].trim();
                    if (cookie.substring(0, name.length + 1) === (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        },
        onCaptchaVerified(recaptchaToken) {
            // console.log("This is the token in question:")
            // console.log(recaptchaToken)
            this.formData.recaptchaToken = recaptchaToken;
        },
        onCaptchaExpired() {
            this.formData.recaptchaToken = '';
        }
    },
}
</script>

<style scoped>
.header-spacer {
    height: 75px;
    background: #333;
}
h1 {
    font-size: 4rem;
    color: #114872;
}

.form-wrap{
    padding-top: 12.25rem;
    padding-bottom: 4rem;
    background: #e8e8e8;
    /* height: 100%; */
}

label, legend{
    color: #114872;
    font-weight: 600;
}

.form-message{
    padding: 2rem 2rem;
    background:transparent;
    border-radius: 1rem;
}

.form-message.active {
     background: #f9e02c;
}

.form-message p {
    margin-bottom: 0;
}

.form-wrap form, .form-info, .form-message{
    width: 60%;
    min-width: 600px;
    margin: 0 auto;
}

.invalid_label {
    color: red;
}

.invalid_field {
    border-color: red;
}

input{
    font-size: 1.5rem;
    color: #333333;
}

/* input, select{
    height: 5rem;
    border: .1rem solid#d0d0d0;

} */

input, select, button{
    border-radius: 1rem;
}

button{
    margin-top: 1.25rem;
}

::placeholder {
    color: #adadad;
}

@media (max-width: 769px){
    .form-wrap form, .form-info, .form-message{
        width: 90%;
        min-width: auto;
    }

}
</style>